import css from './grid.module.scss';
import Skeleton from '../../common/skeleton';
import Conditional from '../../common/conditional';

interface GridProps {
	total: number;
	label: string;
	icon: string;
	loading?: boolean;
}

const Grid = (props: GridProps) => {
	return (
		<div className={css.gridBox + ' col '}>
			<i className={'bi bi-' + props.icon}></i>
			<div className="mx-4">
				<Conditional isVisible={!!props.loading}>
					<Skeleton count={2} />
					<Skeleton className={css.gridBoxButtonActive} />
				</Conditional>

				<Conditional isVisible={!props.loading}>
					<div className={css.gridBoxNumber}>{props.total}</div>
					<div className={css.gridBoxDetails}>{props.label}</div>
					<div className={css.gridBoxButtonActive}>
						<span>View {props.label}</span>
						<i className="bi bi-chevron-right"></i>
					</div>
				</Conditional>
			</div>
		</div>
	);
};

export default Grid;
